<script>
  /**
   * Bulma の テキストエリア
   * @see https://bulma.io/documentation/form/textarea
   */
  import Field from './Field.svelte'

  export let id
  export let name
  export let label
  export let placeholder = undefined
  export let required = undefined

  let attributes = {}

  if (placeholder) attributes.placeholder = placeholder
</script>

<Field {id} {label}>
  <textarea class="textarea" {id} {name} {...attributes} {required} />
</Field>
